import React from 'react';

import { designSystem } from '@/styles/theme';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const NavTopicIcon: React.FC<IconProps> = ({ width = 24, height = 24, color = designSystem.colors.primary }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C16.5 22 19 18.5 19 15C19 11 16 8 16 8C16 8 15 11 13 12C13 12 14 9 12 5C12 5 10 8 8 10C6 12 5 13.5 5 15C5 18.5 7.5 22 12 22Z" stroke={color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 22C10 22 8.5 20.5 8.5 18C8.5 15.5 12 13 12 13C12 13 15.5 15.5 15.5 18C15.5 20.5 14 22 12 22Z" stroke={color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default NavTopicIcon;
